<div
    class="tw-flex tw-flex-col tw-gap-[30px] tw-py-[50px] lg:tw-px-[80px] md:tw-px-[50px] tw-px-[28px]"
>
    <div class="tw-flex tw-flex-col tw-items-center tw-gap-[18px]">
        <span
            class="tw-text-[28px] tw-font-bold tw-leading-[140%] tw-text-[#024B3F] tw-text-center"
            >Acknowledgements</span
        >
        <span
            class="tw-text-[14px] tw-leading-[15px] tw-font-normal tw-text-center tw-max-w-[748px]"
            >The SME ESG Jumpstart Portal and Guide were jointly-developed by
            the JC3 SME Focus Group comprising of the following
            institutions:</span
        >
    </div>
    <div class="tw-flex tw-flex-col">
        <!-- BNM and UOB logos (desktop, tab & mobile) -->
        <div class="tw-flex tw-justify-center tw-gap-x-[18px] tw-mb-[30px]">
            <div *ngFor="let item of bnmUobLogo">
                <a
                    [href]="item.link"
                    target="_blank"
                    [attr.ga-event-id]="
                        'logo_' + makeSlug(item.title) + '_button_jc3_click'
                    "
                    [attr.ga-event-category]="'JC3 Button'"
                    [attr.ga-event-label]="'Logo Click'"
                    ga-track="track"
                >
                    <div
                        class="tw-flex tw-items-center tw-justify-center tw-h-[64px] tw-w-[80px] md:tw-h-[80px] md:tw-w-[100px] lg:tw-h-[80px] lg:tw-w-[100px]"
                    >
                        <img
                            [attr.ga-event-id]="
                                'logo_' +
                                makeSlug(item.title) +
                                '_button_jc3_click'
                            "
                            [attr.ga-event-category]="'JC3 Button'"
                            [attr.ga-event-label]="'Logo Click'"
                            ga-track="track"
                            [alt]="item.title"
                            [src]="item.image"
                            class="tw-max-h-full tw-max-w-full tw-w-auto"
                        />
                    </div>
                </a>
            </div>
        </div>

        <!-- Banks + Insurance + Others (desktop only) -->
        <div
            class="tw-hidden lg:tw-flex lg:tw-flex-wrap tw-justify-center tw-gap-x-[18px] tw-gap-y-[30px]"
        >
            <div
                *ngFor="let item of desktopLogos"
                class="tw-flex tw-justify-center lg:tw-w-[calc(100%/7_-_26px)]"
            >
                <a
                    [href]="item.link"
                    target="_blank"
                    [attr.ga-event-id]="
                        'logo_' + makeSlug(item.title) + '_button_jc3_click'
                    "
                    [attr.ga-event-category]="'JC3 Button'"
                    [attr.ga-event-label]="'Logo Click'"
                    ga-track="track"
                >
                    <div
                        class="tw-flex tw-items-center tw-justify-center tw-h-[64px] tw-w-[80px] md:tw-h-[80px] md:tw-w-[100px] lg:tw-h-[80px] lg:tw-w-[100px]"
                    >
                        <img
                            [attr.ga-event-id]="
                                'logo_' +
                                makeSlug(item.title) +
                                '_button_jc3_click'
                            "
                            [attr.ga-event-category]="'JC3 Button'"
                            [attr.ga-event-label]="'Logo Click'"
                            ga-track="track"
                            [alt]="item.title"
                            [src]="item.image"
                            class="tw-max-h-full tw-max-w-full tw-w-auto"
                        />
                    </div>
                </a>
            </div>
        </div>

        <!-- Tab & Mobile -->
        <div class="tw-flex tw-flex-col tw-gap-y-[20px] lg:tw-hidden">
            <!-- banks row -->
            <div
                class="tw-gap-x-[18px] tw-gap-y-[20px] tw-grid tw-grid-cols-3 md:tw-grid-cols-4 tw-justify-items-center"
            >
                <div
                    *ngFor="let item of banksLogo"
                    class="tw-flex tw-justify-center"
                >
                    <a
                        [href]="item.link"
                        target="_blank"
                        class="tw-block"
                        [attr.ga-event-id]="
                            'logo_' + makeSlug(item.title) + '_button_jc3_click'
                        "
                        [attr.ga-event-category]="'JC3 Button'"
                        [attr.ga-event-label]="'Logo Click'"
                        ga-track="track"
                    >
                        <div
                            class="tw-flex tw-items-center tw-justify-center tw-h-[64px] tw-w-[80px] md:tw-h-[80px] md:tw-w-[100px] lg:tw-h-[80px] lg:tw-w-[100px]"
                        >
                            <img
                                [attr.ga-event-id]="
                                    'logo_' +
                                    makeSlug(item.title) +
                                    '_button_jc3_click'
                                "
                                [attr.ga-event-category]="'JC3 Button'"
                                [attr.ga-event-label]="'Logo Click'"
                                ga-track="track"
                                [alt]="item.title"
                                [src]="item.image"
                                class="tw-max-h-full tw-max-w-full tw-w-auto"
                            />
                        </div>
                    </a>
                </div>
            </div>
            <!-- insurance row -->
            <div
                class="tw-flex tw-flex-wrap tw-justify-center tw-gap-x-[18px] tw-gap-y-[20px]"
            >
                <div
                    *ngFor="let item of insuranceLogo"
                    class="tw-flex tw-justify-center"
                >
                    <a
                        [href]="item.link"
                        target="_blank"
                        class="tw-block"
                        [attr.ga-event-id]="
                            'logo_' + makeSlug(item.title) + '_button_jc3_click'
                        "
                        [attr.ga-event-category]="'JC3 Button'"
                        [attr.ga-event-label]="'Logo Click'"
                        ga-track="track"
                    >
                        <div
                            class="tw-flex tw-items-center tw-justify-center tw-h-[64px] tw-w-[80px] md:tw-h-[80px] md:tw-w-[100px] lg:tw-h-[80px] lg:tw-w-[100px]"
                        >
                            <img
                                [attr.ga-event-id]="
                                    'logo_' +
                                    makeSlug(item.title) +
                                    '_button_jc3_click'
                                "
                                [attr.ga-event-category]="'JC3 Button'"
                                [attr.ga-event-label]="'Logo Click'"
                                ga-track="track"
                                [alt]="item.title"
                                [src]="item.image"
                                class="tw-max-h-full tw-max-w-full tw-w-auto"
                            />
                        </div>
                    </a>
                </div>
            </div>
            <!-- others row - mobile & desktop -->
            <div
                class="tw-gap-x-[18px] tw-gap-y-[20px] tw-grid tw-grid-cols-3 md:tw-hidden tw-justify-items-center"
            >
                <div
                    *ngFor="let item of othersLogo"
                    class="tw-flex tw-justify-center"
                >
                    <a
                        [href]="item.link"
                        target="_blank"
                        class="tw-block"
                        [attr.ga-event-id]="
                            'logo_' + makeSlug(item.title) + '_button_jc3_click'
                        "
                        [attr.ga-event-category]="'JC3 Button'"
                        [attr.ga-event-label]="'Logo Click'"
                        ga-track="track"
                    >
                        <div
                            class="tw-flex tw-items-center tw-justify-center tw-h-[64px] tw-w-[80px] md:tw-h-[80px] md:tw-w-[100px] lg:tw-h-[80px] lg:tw-w-[100px]"
                        >
                            <img
                                [attr.ga-event-id]="
                                    'logo_' +
                                    makeSlug(item.title) +
                                    '_button_jc3_click'
                                "
                                [attr.ga-event-category]="'JC3 Button'"
                                [attr.ga-event-label]="'Logo Click'"
                                ga-track="track"
                                [alt]="item.title"
                                [src]="item.image"
                                class="tw-max-h-full tw-max-w-full tw-w-auto"
                            />
                        </div>
                    </a>
                </div>
            </div>
            <!-- others row tablet - 1 -->
            <div
                class="md:tw-gap-x-[18px] md:tw-gap-y-[20px] md:tw-grid md:tw-grid-cols-4 lg:tw-hidden tw-hidden tw-justify-items-center"
            >
                <div
                    *ngFor="let item of othersLogo.slice(0, 4)"
                    class="tw-flex tw-justify-center"
                >
                    <a
                        [href]="item.link"
                        target="_blank"
                        class="tw-block"
                        [attr.ga-event-id]="
                            'logo_' + makeSlug(item.title) + '_button_jc3_click'
                        "
                        [attr.ga-event-category]="'JC3 Button'"
                        [attr.ga-event-label]="'Logo Click'"
                        ga-track="track"
                    >
                        <div
                            class="tw-flex tw-items-center tw-justify-center tw-h-[64px] tw-w-[80px] md:tw-h-[80px] md:tw-w-[100px] lg:tw-h-[80px] lg:tw-w-[100px]"
                        >
                            <img
                                [attr.ga-event-id]="
                                    'logo_' +
                                    makeSlug(item.title) +
                                    '_button_jc3_click'
                                "
                                [attr.ga-event-category]="'JC3 Button'"
                                [attr.ga-event-label]="'Logo Click'"
                                ga-track="track"
                                [alt]="item.title"
                                [src]="item.image"
                                class="tw-max-h-full tw-max-w-full tw-w-auto"
                            />
                        </div>
                    </a>
                </div>
            </div>
            <!-- others row tablet - 2 -->
            <div
                class="md:tw-gap-x-[18px] md:tw-gap-y-[20px] lg:tw-hidden tw-hidden md:tw-flex md:tw-flex-wrap tw-justify-center"
            >
                <div
                    *ngFor="let item of othersLogo.slice(4)"
                    class="tw-flex tw-justify-center"
                >
                    <a
                        [href]="item.link"
                        target="_blank"
                        class="tw-block"
                        [attr.ga-event-id]="
                            'logo_' + makeSlug(item.title) + '_button_jc3_click'
                        "
                        [attr.ga-event-category]="'JC3 Button'"
                        [attr.ga-event-label]="'Logo Click'"
                        ga-track="track"
                    >
                        <div
                            class="tw-flex tw-items-center tw-justify-center tw-h-[64px] tw-w-[80px] md:tw-h-[80px] md:tw-w-[100px] lg:tw-h-[80px] lg:tw-w-[100px]"
                        >
                            <img
                                [attr.ga-event-id]="
                                    'logo_' +
                                    makeSlug(item.title) +
                                    '_button_jc3_click'
                                "
                                [attr.ga-event-category]="'JC3 Button'"
                                [attr.ga-event-label]="'Logo Click'"
                                ga-track="track"
                                [alt]="item.title"
                                [src]="item.image"
                                class="tw-max-h-full tw-max-w-full tw-w-auto"
                            />
                        </div>
                    </a>
                </div>
            </div>
        </div>
    </div>
    <span class="tw-text-[13px] tw-font-normal tw-text-center"
        >Logos remain the property of the respective organisations and displayed
        for informational purposes only.</span
    >
</div>
